module.exports = __webpack_public_path__ + "img/img6.62f8994c.png";